/*eslint-disable */
<template>
  <b-container fluid>
    <div>
      <iq-card>
        <template v-slot:headerTitle>
          <b-row class="mt-2">
            <b-col class="col-12 col-sm-8 col-md-8 col-lg-8">
              <h4 class="card-title">
                <div class="profile-img-edit">
                  <img v-if="studentData.image" class="profile-pic border" :src="studentData.image? studentData.image : vmUserImage" alt="profile-pic" style=" height: 50px; width: 50px; object-fit: cover;"/>
                  <b-avatar v-else class="avatar-20 mr-2 border" :text="getFirstLetterOfAString(studentData.user_name)"></b-avatar>
                  <span class="pl-2">
                    <div style="min-height: 40px;" class="align-items-center">
                      <span class="pointer primary-color mr-2" @click="gotoUserProfile(studentData.user_id)">{{ studentData.user_name }}</span>
                      <span class="mr-2">
                        <b-badge v-if="spcmObj.spcm_tnc == 1 && spcmObj?.spcm_contract && JSON.stringify(spcmObj.spcm_contract).includes('s3.amazonaws.com')" class="text-wrap mr-2" :style="getCounsellingStateColorCode('tnc_1')">
                          <small>Terms Accepted</small>
                        </b-badge>
                        <b-badge v-else-if="spcmObj.spcm_tnc != 1" class="text-wrap mr-2" :style="getCounsellingStateColorCode('tnc_0')">
                          <small>Terms Not Accepted</small>
                        </b-badge>
                        <b-badge v-else class="text-wrap mr-2" :style="getCounsellingStateColorCode('tnc_0')">
                          <small>Contract Pending</small>
                        </b-badge>

                        <b-badge v-if="applicationStatus && userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" title="Change Status" class="text-wrap pointer mr-2" @click="showSpcmStatusUpdateOpenDialog(spcmObj)" :style="getCounsellingStateColorCode(applicationStatus)">
                          <small>{{ SPCM_STATE_LIST[applicationStatus] }}</small>
                        </b-badge>
                        <b-badge v-else-if="applicationStatus" title="Change Status" class="text-wrap mr-2" :style="getCounsellingStateColorCode(applicationStatus)">
                          <small>{{ SPCM_STATE_LIST[applicationStatus] }}</small>
                        </b-badge>
                      </span>

                      <NotificationsModal :propNotificationObj="propNotificationObj" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"/>
                    </div>
                  </span>
                </div>
              </h4>
              <ul class="p-0 mb-1 user_details" style="line-break:anywhere">
                <b>Student Details</b><br>

                <span v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'">
                  Id:&nbsp;{{ studentData.user_id }}
                </span>
                <li><i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;{{ studentData.user_email }}</li>
                <li><i class="fa fa-phone" aria-hidden="true"></i>&nbsp;{{ studentData.user_mobile }}</li>
                <li v-if="user_profile?.education && user_profile?.education.length > 0"><i class="fa fa-people-roof" aria-hidden="true"></i>&nbsp;&nbsp;{{ user_profile?.education[0]?.education?.class_name }}&nbsp;<span v-if="user_profile?.education[0]?.examination_body">({{ user_profile?.education[0]?.examination_body }})</span></li><br>

                <b>Parents Details</b>
                <li v-for="(item, index) of parentList" :key="index+item" class="d-flex parent_detail_row">
                  <span class="parent_detail_col"><i class="fa fa-user" aria-hidden="true"></i> {{item.parent_name}}</span>
                  <span class="parent_detail_col"><i v-if="item.parent_email" class="fa fa-envelope" aria-hidden="true"></i> {{item.parent_email}}</span>
                  <span class="parent_detail_col"><i v-if="item.parent_mobile" class="fa fa-phone" aria-hidden="true"></i> {{ item.parent_mobile }}</span>
                </li>
                <li v-if="addressObj?.addressLineTwo"><i class="fa fa-map-marker font-size-18" aria-hidden="true"></i> {{ addressObj.addressLineTwo }} {{ addressObj.user_city }} {{ addressObj.user_state }}</li>
              </ul>
            </b-col>
            <b-col class="col-12 col-sm-4 col-md-4 col-lg-4 mt-4">
              <div class="" @click="goToDashboard" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'">
                <b-button class="mr-1" variant="primary">
                  <span v-if="landedFrom == 'testseries'">Testseries Dashboard</span>
                  <span v-else>Counseling Dashboard V1</span>
                </b-button>
              </div>
              <div v-if="landedFrom != 'testseries'">
                <b>Lead Strategist:</b>&nbsp;{{ spcmObj?.counsellor_name && spcmObj?.counsellor_id != "1" ? spcmObj.counsellor_name : 'Awaiting Allocation' }}<br>
                <b-button class="bg-color mt-1 pr-2 pl-0" @click="spcmStudentCounsellorTeam(spcmObj)"><i class="font-size-18 fa fa-users primary-color" title="View Team" aria-hidden="true"></i></b-button>
                <b-button class="bg-color mt-1 pr-2 pl-0" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"><i class="fa ri-question-answer-fill pointer" aria-hidden="true" style="font-size: 20px; color: var(--iq-primary);" @click="openCounsellingQuizModalv1(spcmObj)" title="View Student Pre-Counseling Quiz"></i></b-button>
                <!-- <b-button class="bg-color mt-1 pr-2 pl-0" @click="openAdmission(spcmObj.user_id)"><i class="font-size-18 fa fa-solid fa-file-text primary-color" title="Admisson Dashboard"></i></b-button> -->
                <b-button class="bg-color mt-1 pr-2 pl-0" @click="openSendmailToUserModal(spcmObj)" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"><i class="font-size-18 fa fa-envelope primary-color" title="Send Email" aria-hidden="true"></i></b-button>
                <b-button class="bg-color mt-1 pr-2 pl-0" @click="gotoFirefliesDashboard(spcmObj)" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"><i class="font-size-18 fa fa-fire primary-color" title="Open Fireflies" aria-hidden="true"></i></b-button>
                <b-button class="bg-color mt-1 pr-2 pl-0" @click="openStudentDocsList(spcmObj)"><i class="font-size-18 fa-regular fa-file-word primary-color" title="Manage Student Documents"></i></b-button>
                <b-button class="bg-color mt-1 pr-2 pl-0" @click="viewContract(spcmObj)" size="sm" title="GIDE Counseling Contract"><i class="fa-solid fa-file-contract font-size-18 primary-color" aria-hidden="true"></i></b-button>
                <!-- <b-button class="bg-color mt-1 pr-2 pl-0" @click="viewContract1(spcmObj)" size="sm" title="GIDE Counseling Contract 11"><i class="fa-solid fa-file-contract font-size-18 primary-color" aria-hidden="true"></i></b-button> -->
              </div>
              <div class="mt-4">
                <b>Enrolled Products</b><br>
                <ProductSubscriptionPlan :propStudentData="studentData"/>
              </div>
            </b-col>
          </b-row>
        </template>
      </iq-card>
    </div>

    <div class="hook iq-card p-4">
      <h6><span class="">Hook Statement : </span>{{ spcmObj.spcm_hook }}
        <i data-v-0dcdc260="" @click="spcmHookStatementAddEdit(spcmObj)" title="Edit Counselor" class="ri-ball-pen-fill m-0 font-size-14 primary-color"></i>
      </h6>
    </div>

    <div id="reviewAdmission">
      <!-- Tabs visible in student view workflow only -->
      <div class="iq-card showFlexListDiv">
        <div class="user-tabing showFlexList">
          <tab-nav v-if="!cvLoading && studentView && (this.spcmObj.spcm_total_session < 0 || !this.spcmObj.hasOwnProperty('spcm_total_session'))" :pills="true" id="pills-tab" class="nav nav-pills d-flex align-items-center justify-content-center profile-feed-items p-0 m-0">
            <div  class="flex-fill p-0" @click="selectedTab = cvTabObj.personalDetail">
              <tab-nav-items class="flex-fill p-0" :active="selectedTab === cvTabObj.personalDetail" id="pills-personalDetail-tab" href="#pills-personalDetail-tab"
                ariaControls="pills-personalDetail-tab" role="tab" :ariaSelected="selectedTab === cvTabObj.personalDetail" :title="cvTabObj.personalDetail" />
            </div>

            <div  class="flex-fill p-0" :class="!spcmObj.spcm_id ? 'disableClick' : ''"  @click="selectedTab = cvTabObj.education">
              <tab-nav-items class="flex-fill p-0" :active="selectedTab === cvTabObj.education" id="pills-activity-tab" href="#profile-activity"
                ariaControls="pills-profile" role="tab" :ariaSelected="selectedTab === cvTabObj.education" :title="cvTabObj.education" />
            </div>

            <div  class="flex-fill p-0" :class="!spcmObj.spcm_id ? 'disableClick' : ''"  @click="selectedTab = cvTabObj.chooseInterests">
              <tab-nav-items class="flex-fill p-0" :active="selectedTab === cvTabObj.chooseInterests" id="pills-chooseInterests-tab" href="#profile-chooseInterests"
                ariaControls="pills-chooseInterests" role="tab" :ariaSelected="selectedTab === cvTabObj.chooseInterests" :title="cvTabObj.chooseInterests" />
            </div>

            <div  class="flex-fill p-0" :class="!spcmObj.spcm_id ? 'disableClick' : ''" v-if="!spcmObj.spcm_id || spcmObj.spcm_total_session < 1"  @click="selectedTab = cvTabObj.chooseSlot">
              <tab-nav-items class="flex-fill p-0" :active="selectedTab === cvTabObj.chooseSlot" id="pills-chooseSlot-tab" href="#profile-chooseSlot"
                ariaControls="pills-chooseSlot" role="tab" :ariaSelected="selectedTab === cvTabObj.chooseSlot" :title="cvTabObj.chooseSlot" />
            </div>

            <div class="flex-fill p-0" :class="!spcmObj.spcm_id ? 'disableClick' : ''" @click="selectedTab = cvTabObj.counselling">
              <tab-nav-items  class="flex-fill p-0"  :active="selectedTab === cvTabObj.counselling" id="pills-counselling-tab"  href="#pills-counselling"
                ariaControls="pills-counselling" role="tab" :ariaSelected="selectedTab === cvTabObj.counselling" :title="cvTabObj.counselling" />
            </div>
          </tab-nav>
        </div>
      </div><!-- Tabs visible in student view workflow only -->

      <div class="iq-card showFlexListDiv">
        <b-container fluid class="p-0">
          <b-row class="m-0 Documents">
            <!-- Personal Information -->
            <b-col md="12" class="pl-4 pr-4 pb-4 pt-2" v-show="(selectedTab === cvTabObj.personalDetail || selectedTab === cvTabObj.review)">
              <PersonalInfo v-if="studentData && Object.keys(studentData).length" :propUserId="studentData.user_id" :propUserData="studentData" :propModuleType="'ADM'"/>
            </b-col><!-- Personal Information -->

            <!-- Education -->
            <b-col md="12" class="pl-4 pr-4 pb-4 pt-2" :key="spcmObj.spcm_id+'_Education'" v-show="(selectedTab === cvTabObj.education || selectedTab === cvTabObj.review)">
              <div class="mt-3 table_scroll">
                <h4>Education
                  <span class="educationAddIcon" v-if="studentView && (!spcmObj.spcm_id || editMode)" @click="showAddEducation()">
                    <i class="fa-solid fa-circle-plus"></i>
                  </span>
                </h4>
                <hr class="w-100 theme_color"/>
                <div class="mt-3" v-if="user_profile.education && user_profile.education.length">
                  <Education :propUserId="studentData.user_id" :propUserView="userData.user_id == spcmObj.user_id" :propEducationList="user_profile.education" :propExcObjList="extraCurricularListObj"  @emitUserProfileEducation="updatedEducationDetails"></Education>
                </div>
              </div>
            </b-col><!-- Education -->

            <!-- Choose Slot -->
            <b-col md="12" class="pl-4 pr-4 pb-4 pt-2"  v-show="(selectedTab === cvTabObj.chooseSlot || selectedTab === cvTabObj.review)">
              <div class="mt-3 table_scroll">
                <h4>Choose Slot
                </h4>
                <hr class="w-100 theme_color"/>
                <!-- show the choose slot to user only -->
                <div v-if="spcmObj && spcmObj.spcm_id && userData.user_role == 'USERROLE11114'">
                  <SpcmSessions :propSpcmId="spcmObj.spcm_id" :propSpcmObj="spcmObj" :propStudentData="studentData" @emitSessionUpdated="spcmSessionUpdate"></SpcmSessions>
                </div>
              </div>
            </b-col><!-- Choose Slot -->

            <!-- Choose Interests -->
            <b-col md="12" class="review_form_spacing" v-show="(selectedTab === cvTabObj.chooseInterests || selectedTab === cvTabObj.review)">
              <div class="mt-3 table_scroll">
                <h4>Choose Interests
                </h4>
                <hr class="w-100 theme_color"/>
                <Interest :propModalView="false" @emitCloseInterestModal="goToNextTab"></Interest>
              </div><!-- Choose Interests -->
            </b-col><!-- Choose Interests -->

            <!-- Main Implementation of Counseling Notes -->
            <b-col md="12" class="pl-4 pr-4 pb-4 pt-2 review_form_spacingSPCM mb-0 p-0" :key="spcmObj.spcm_id+ '_Session'" v-show="(selectedTab === cvTabObj.counselling)">
              <div class="iq-card mb-3">
                <ul class="nav nav-pills nav-fill counseling-main-nav" role="tablist">
                  <li class="nav-item" @click="mainViewTab = 'session_detail'">
                    <a class="nav-link" :class="{ active: mainViewTab === 'session_detail' }" href="javascript:void(0)">
                      <i class="ri-chat-history-line mr-2"></i>Appointments
                    </a>
                  </li>
                  <li class="nav-item" @click="mainViewTab = 'session_notes'">
                    <a class="nav-link" :class="{ active: mainViewTab === 'session_notes' }" href="javascript:void(0)">
                      <i class="ri-chat-history-line mr-2"></i>
                      Sessions & Notes
                    </a>
                  </li>
                  <li class="nav-item" @click="mainViewTab = 'actions'">
                    <a class="nav-link" :class="{ active: mainViewTab === 'actions' }" href="javascript:void(0)">
                      <i class="ri-settings-4-line mr-2"></i>Recommendations & Tools
                    </a>
                  </li>
                </ul>
              </div>

              <template>
                <b-row v-if="mainViewTab === 'session_detail'">
                  <!-- Left Menu Panel for Academic / Test Scores (Burger Menu Responsive Drawer) -->
                  <b-col class="col-12 col-md-3 right_data" v-if="leftmenuIcon || !IS_MOBILE_DEVICE">
                    <div class="right_data_center">
                      <i v-if="IS_MOBILE_DEVICE" @click="leftmenuIcon = !leftmenuIcon" class="fa fa-times close_left_data" aria-hidden="true"></i>

                      <!-- Academic Score Section -->
                      <div class="mt-1 p-3">
                        <h5 style="font-weight:500">Academic Score
                          <span class="educationAddIcon" v-if="studentData.user_id == this.userData.user_id" @click="showAddEducation(spcmObj.user_id)">
                             <i class="fa-solid fa-circle-plus"></i>
                          </span>
                        </h5>
                        <hr/>
                        <div v-if="user_profile.education && user_profile.education.length" class="user_acadmic_info_spcm">
                          <Education :propUserId="studentData.user_id" :propUserView="userData.user_id == spcmObj.user_id" :propEducationList="user_profile.education"  :propAcadmicScore=true :propPersonalDocument=false @emitUserProfileEducation="updatedEducationDetails"></Education>
                        </div>
                        <div v-else>
                          <p>No education data available.</p>
                        </div>
                      </div>

                      <!-- Test / Assessment Scores Section -->
                      <div class="mt-1 p-3" v-if="userProgramTest && Object.keys(userProgramTest).length">
                        <h5 style="font-weight:500">Test / Assessment Scores
                          <span v-if="userData.user_id  == studentData.user_id" class="educationAddIcon" @click="showProgramModal">
                            <i class="fa-solid fa-circle-plus"></i>
                          </span>
                        </h5>
                        <hr>
                        <ul style="list-style-type: disc" class="p-0">
                          <div v-if="userProgramTest && Object.keys(userProgramTest).length">
                            <div class="educationCard pt-2" v-for="(item, index) in userProgramTest" :key="index + 'program'">
                              <ProgramTest
                                :propStudentScore="item"
                                :propGideUser="studentData"
                                :propOpenedInModal="false"
                                @emitCloseProgramModal="closeProgramModal"
                              />
                            </div>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </b-col>

                  <!-- Main Monthly Overview Calendar Panel -->
                  <b-col class="col-12 col-md-9" v-if="spcmObj && Object.keys(spcmObj).length">
                    <!-- Left Burger Toggle for Academics/Scores on Mobile View -->
                    <div class="main-circle" @click="leftmenuIcon = !leftmenuIcon">
                      <i class="ri-menu-line menu_icon_left"></i>
                    </div>

                    <SpcmCounselorCalendar :propOpenedInModal="false" :propSpcmObj="spcmObj" :propStudentData="studentData"/>
                  </b-col>
                </b-row>

                <b-row v-if="mainViewTab === 'session_notes'">
                  <b-col lg="4" md="12" class="mb-3 right_data" v-if="leftmenuIcon || !IS_MOBILE_DEVICE">
                    <div class="right_data_center">
                      <i v-if="IS_MOBILE_DEVICE" @click="leftmenuIcon = !leftmenuIcon" class="fa fa-times close_left_data" aria-hidden="true"></i>
                      <template v-if="spcmObj.spcm_id">
                        <SpcmSessions :propSpcmId="spcmObj.spcm_id" :propSpcmObj="spcmObj" :propStudentData="studentData" :propViewList="true"></SpcmSessions>
                      </template>
                    </div>
                  </b-col><b-col lg="8" md="12">
                    <div class="main-circle" @click="leftmenuIcon = !leftmenuIcon">
                      <i class="ri-menu-line menu_icon_left "></i>
                    </div>
                    <section v-if="spcmObj && spcmObj.spcm_id">
                      <SpcmNoteList :propSpcmObj="spcmObj"></SpcmNoteList>
                    </section>
                  </b-col>
                </b-row>
                <b-row  v-if="mainViewTab === 'actions'">
                  <b-col md="12">
                    <div class="right_data_center">
                      <div>
                        <h6 class="mt-2">
                          <ul class="nav nav-pills mb-3 nav-fill nav-tabs" id="pills-tab-1" role="tablist">
                            <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.education">
                              <a class="nav-link"
                                :class="{ active: counsellingSelectedTab === cvTabObj.education }"
                                id="pills-education-tab-fill"
                                data-toggle="pill"
                                href="#pills-education-fill"
                                role="tab"
                                aria-controls="pills-education"
                                aria-selected="false"
                              >
                                Education
                              </a>
                            </li>
                            <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.programTest">
                              <a class="nav-link" id="pills-programTest-tab-fill" data-toggle="pill" href="#pills-programTest-fill" role="tab" aria-controls="pills-programTest" aria-selected="true">
                                Program Test
                              </a>
                            </li>
                            <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.testPrepPerformance">
                              <a class="nav-link" id="pills-testPrepPerformance-tab-fill" data-toggle="pill" href="#pills-testPrepPerformance-fill" role="tab" aria-controls="pills-testPrepPerformance" aria-selected="false">
                                Testprep
                              </a>
                            </li>
                            <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.profileBuildingReco">
                              <a class="nav-link" id="pills-profileBuildingReco-tab-fill" data-toggle="pill" href="#pills-profileBuildingReco-fill" role="tab" aria-controls="pills-profileBuildingReco" aria-selected="true">
                                Profile Building
                              </a>
                            </li>
                            <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.passionProjects">
                              <a class="nav-link" id="pills-passionProjects-tab-fill" data-toggle="pill" href="#pills-passionProjects-fill" role="tab" aria-controls="pills-passionProjects" aria-selected="false">
                                Passion Projects
                              </a>
                            </li>
                            <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.universityReco">
                              <a class="nav-link"
                                id="pills-universityReco-tab-fill"
                                data-toggle="pill"
                                href="#pills-universityReco-fill"
                                role="tab"
                              >
                                Shortlisted Universities
                              </a>
                            </li>
                            <!-- <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.scholarshipReco">
                              <a class="nav-link" id="pills-scholarshipReco-tab-fill" data-toggle="pill" href="#pills-scholarshipReco-fill" role="tab" aria-controls="pills-scholarshipReco" aria-selected="true">
                                Scholarship Reco
                              </a>
                            </li> -->
                            <!-- <li class="nav-item" @click="counsellingSelectedTab = cvTabObj.leaderBoard">
                              <a class="nav-link" id="pills-leaderBoard-tab-fill" data-toggle="pill" href="#pills-leaderBoard-fill" role="tab" aria-controls="pills-leaderBoard" aria-selected="false">
                                Leader Board
                              </a>
                            </li> -->
                          </ul>
                        </h6>
                      </div>

                      <!-- University Recommendations -->
                      <div v-show="counsellingSelectedTab == cvTabObj.universityReco">
                        <div class="mt-3">
                          <SpcmStudentUniversityRecov1 @refreshScholarshipReco="refreshScholarshipReco" :propSpcmObj="spcmObj"/>
                        </div>
                      </div><!-- University Recommendations -->

                      <!-- Profile Building Recommendations -->
                      <div v-show="counsellingSelectedTab == cvTabObj.profileBuildingReco">
                        <div class="mt-3">
                          <SpcmStudentProfileBuildingReco :propSpcmObj="spcmObj"/>
                        </div>
                      </div><!-- Profile Building Recommendations -->

                      <!-- Programs & Test -->
                      <div v-show="counsellingSelectedTab == cvTabObj.programTest">
                        <div class="mt-3">
                          <div class="iq-card">
                              <div class="iq-card-body">
                                <div class="">
                                  <h5 class="m-bold pl-2 w-100 pr-2 mb-2">
                                    Programs &amp; Test
                                    <span v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111' || userData.user_id  == studentData.user_id" class="educationAddIcon" @click="showProgramModal">
                                      <i class="fa-solid fa-circle-plus"></i>
                                    </span>
                                  </h5>
                                  <div v-if="userProgramTest && Object.keys(userProgramTest).length">
                                  <div class="educationCard pt-2" v-for="(item, index) in userProgramTest" :key="index+'program'" >
                                    <ProgramTest :propGideUser="studentData" :propProgramDetail="item" :propOpenedInModal="false"></ProgramTest>
                                  </div>
                                </div>
                                  <div v-else class="mb-4 ml-2">
                                    Student has not updated this section
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div><!-- Programs & Test -->

                      <!-- TestPrep Performance -->
                      <div v-show="counsellingSelectedTab == cvTabObj.testPrepPerformance">
                        <div class="mt-3">
                          <TestPrep
                            :studentUserId="studentData.user_id"
                            :programTests="userProgramTest"
                            @emitAddProgramTest="showProgramModal"
                            @emitEditExam="showProgramModal"
                          />
                        </div>
                      </div><!-- TestPrep Performance -->

                      <!-- Scholarship Recommendations -->
                      <div v-show="counsellingSelectedTab == cvTabObj.scholarshipReco">
                        <div class="mt-3">
                          <SpcmStudentScholarshipReco :key="refreshScholarshipRecoKey" :propSpcmObj="spcmObj"/>
                        </div>
                      </div><!-- Scholarship Recommendations -->

                      <!-- <div v-show="counsellingSelectedTab == cvTabObj.personalDetail">
                        <div class="mt-3">
                          <PersonalInfo :propUserId="spcmObj.user_id" :propUserData="studentData" :propModuleType="'SPCM'"/>
                        </div>
                      </div> -->
                      <div class="p-3 iq-card" v-show="counsellingSelectedTab == cvTabObj.chooseInterests">
                        <UserInterest v-if="spcmObj.user_id" :propUserId="spcmObj.user_id"/>
                      </div>
                      <div class="" v-show="counsellingSelectedTab == cvTabObj.leaderBoard">
                        <div class="p-3  iq-card" v-if="spcmObj.user_id">
                          <AppResultLeaderBoard :propUserId="spcmObj.user_id" />
                        </div>
                      </div>
                      <div class="p-3 iq-card" v-show="counsellingSelectedTab == cvTabObj.education">
                        <h5 class="m-bold pl-2 w-100 pr-2 mb-2">
                          <span class="educationAddIcon" :v-if="spcmObj.user_id === this.userData.user_id || userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="showAddEducation(spcmObj.user_id)">
                            <i class="fa-solid fa-circle-plus"></i>
                          </span>
                        </h5>
                        <div v-if="user_profile.education && user_profile.education.length">
                          <Education :propUserId="spcmObj.user_id" :propUserView="userData.user_id == spcmObj.user_id" :propEducationList="user_profile.education" :propExcObjList="extraCurricularListObj" @emitUserProfileEducation="updatedEducationDetails"></Education>
                        </div>
                      </div>
                      <!-- passionProjects -->
                      <div v-show="counsellingSelectedTab == cvTabObj.passionProjects">
                        <div class="mt-3">
                          <SpcmStudentProfileBuildingReco :propRoadmapNoteType="4" :propSpcmObj="spcmObj" :propEducationList="user_profile.education"/>
                        </div>
                      </div><!-- passionProjects -->
                    </div>
                  </b-col>
                </b-row>
              </template>
            </b-col><!-- Main Implementation of Counseling Notes -->
          </b-row>
        </b-container>

        <template v-if="addEducationShow">
          <Education :propUserId="spcmObj.user_id" :propEducationForm="educationForm" :propEducationAddShow='addEducationShow' @emitCloseEducationModal="closeEducationModal" @emitUserProfileEducation="updatedEducationDetails">
          </Education>
        </template>

        <!-- SendMail -->
        <b-modal
          v-model="showModelSendMail"
          scrollable
          :title="cvSendMailModalHeader"
        >
          <SendMail :propOpenedInModal="true" :propSendMailObj="sendMailObj" :propModuleName="GideProducts.COUNSELLING" @emitCloseGPathSendMailModal="emitCloseGPathSendMailModal" />
          <template #modal-footer="">
            <b-button size="sm" @click="emitCloseGPathSendMailModal()">
              {{cvbtnModalCancel}}
            </b-button>
          </template>
        </b-modal><!-- SendMail -->

        <!-- Yjs Docs-->
        <b-modal
          v-model="showModelYjs_Doc_List"
          scrollable
          :title="cvYjsDocListModalHeader"
          size="xxl"
          hide-footer
          >
          <YjsDocsList :propOpenedInModal="true" :propYjsDocObj="yjsDocsObj" :propGideUser="studentData" @emitCloseYjsDocsModal="closeStudentDocsList"/>
        </b-modal><!-- Yjs Docs-->

        <!-- Next Button -->
        <div class="footer app_form__admin_three_button mt-2 mb-2 row w-100 ">
          <div class="col-12 mt-1 pt-1 submit_sudent_form pr-0" v-if="selectedTab != cvTabObj.chooseSlot && selectedTab != cvTabObj.counselling && selectedTab != cvTabObj.chooseInterests">
            <b-button size="sm" variant="primary" class="pull-right primary mb-3" @click="goToNextTab()">
              {{selectedTab === cvTabObj.review ? 'Pay and Submit' : 'Save and Next'}}
            </b-button>
          </div>
        </div>

        <ProgramTest :propGideUser="studentData"  v-if="showProgramTestModal" :propProgramDetail="programEditObj" :propOpenedInModal="showProgramTestModal" @emitCloseProgramModal="closeProgramModal"></ProgramTest>

        <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
          <div v-html="toastMsg"></div>
        </b-toast>
      </div>
    </div>

    <!--Spcm Student Counsellor Team -->
    <b-modal
      v-model="showModelSpcmStudentCounsellorTeam"
      scrollable
      :title="cvSpcmStudentCounsellorTeamModalHeader"
      size="xxl"
      hide-footer>
      <SpcmStudentCounsellorTeam :propStudentCounselorTeam="true" :propOpenedInModal="true" :propStudentCounsellorObj="StudentCounsellorTeamObj" @emitCloseStudentCounsellorTeamModal="closeStudentCounsellorTeamModal" />
    </b-modal><!-- Spcm Student Counsellor Team -->

   <!--Spcm Student Hook Statement -->
  <b-modal
    v-model="showModelSpcmHookStatement"
    scrollable
    :title="cvSpcmHookStateMentModalHeader"
    size="xxl"
    hide-footer>
    <p v-if="StudentHookStatement && !StudentHookStatement.spcm_hook">Add student hook statement</p>
    <textarea v-if="StudentHookStatement" v-model="StudentHookStatement.spcm_hook" class="form-control" rows="5"></textarea>
    <b-button class="btn btn-primary mt-3" @click="updateHookStatement()">Submit</b-button>
  </b-modal>

   <!-- Update SPCM Status -->
    <b-modal v-model="showModelSpcmStatusUpdate" size="sm" title="Update Status" ok-title="Update" cancel-title="Cancel">
        <!-- Counselling Status -->
        <b-col sm="12" md="12" lg="12" xl="12" class="mb-2">
          <select v-model="whereFilter.spcm_state" class="form-control">
            <option :value="null" disabled>Choose Status</option>
            <option v-for="(state, index) of SPCM_STATE_LIST" :key="(index+1)" :value="index">
              {{state}}
            </option>
          </select>
        </b-col><!-- Counselling Status -->
        <template #modal-footer="">
          <b-button size="sm" @click="showModelSpcmStatusUpdate = false">{{cvbtnModalCancel}}</b-button>
          <b-button size="sm" variant="primary" @click="spcmStatusUpdate(spcmObj, whereFilter.spcm_state)">Update</b-button>
        </template>
    </b-modal><!-- Update SPCM Status -->

    <!-- Spcm Student Counsellor Form V1 -->
    <b-modal
      v-model="showCounsellingQuizModalv1"
      scrollable
      :title="cvSpcmSpcmCounsellorFormTitle"
      size="xxl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      :hide-header-close="userData.user_role != 'USERROLE11111' && userData.user_role != 'USERROLE11118'"
    >
      <PAQ :propQuestionObj="questionObj" :propParentModuleObj="spcmObj" :propContractId="contractId" @emitClosePreCounsellingQuizModal="closeCounsellingQuizModal" @emitContractTnCAccept="contractTnCAccept"/>
    </b-modal><!--Spcm Student Counsellor Form V1 -->

    <!-- Gide Contract -->
    <b-modal
      v-model="showModalGideContracts"
      scrollable
      size="xl"
      title="GIDE Exclusive Contract"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      :hide-header-close="(userData.user_role != 'USERROLE11111' && userData.user_role != 'USERROLE11118') && !spcmObj.spcm_tnc"
    >
      <GideContract :propOpenedInModal="true" :propGideContractObj="gideCounselingContractObj" :propContractId="contractId" @emitcloseGIDECounselingContractModal="closeGIDECounselingContractModal" @emitContractTnCAccept="contractTnCAccept"/>
    </b-modal><!-- Gide Contract -->
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { User } from "../../../FackApi/api/user.js"
import Utility from "../../../Utils/utility.js"
import Education from "../../../components/UserProfile/Education.vue"
import PersonalInfo from "../../../components/UserProfile/PersonalInfo.vue"
import SpcmNoteList from "../../../components/SpcmNoteList.vue"
import SpcmSessions from "../../../components/SpcmSessions.vue"
import { Spcms } from "../../../FackApi/api/Spcm.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import SPCMStateNumberJson from "../../../FackApi/json/SPCMStateNumber.json"
import { AppResults } from "../../../FackApi/api/appResults.js"
import AppResultLeaderBoard from "../../../components/AppResultLeaderBoard.vue"
import Interest from "../../../components/Interest.vue"
import UserInterest from "../../../components/UserInterest.vue"
import { QuizBanks } from "../../../FackApi/api/quizBank.js"
import userPermission from "../../../Utils/user_permission.js"
import SpcmStudentUniversityRecov1 from "./SpcmStudentUniversityRecov1.vue"
import SpcmStudentProfileBuildingReco from "./SpcmStudentProfileBuildingReco.vue"
import SpcmStudentScholarshipReco from "./SpcmStudentScholarshipReco.vue"
import SpcmStudentCounsellorTeam from "./SpcmStudentCounsellorTeam.vue"
import SendMail from "../../../components/SendMail.vue"
import SendMailModules from "../../../FackApi/json/SendMailModules.json"
import GideProducts from "../../../FackApi/json/GideProducts.json"
import ProgramTest from "../../../components/UserProfile/ProgramTest.vue"
import TestPrep from "../../../components/UserProfile/TestPrepPerformance.vue"
import YjsDocsList from "../YjsDocs/YjsDocsList.vue"
import GideContract from "./GideContract.vue"
import { UserParent } from "../../../FackApi/api/userParent.js"
// import CalendarDashboard from "../../../components/calendar.vue"
import SpcmCounselorCalendar from "../../../components/SpcmCounselorCalendar.vue"
import NotificationsModal from "./NotificationsModal.vue"
import PAQ from "./PAQ.vue"
import ProductSubscriptionPlan from "../../../components/ProductSubscriptionPlan.vue"

export default {
  name: "SpcmView",
  components: {
    Education,
    PersonalInfo,
    SpcmNoteList,
    SpcmSessions,
    AppResultLeaderBoard,
    Interest,
    UserInterest,
    SpcmStudentUniversityRecov1,
    SpcmStudentProfileBuildingReco,
    SpcmStudentScholarshipReco,
    SpcmStudentCounsellorTeam,
    SendMail,
    ProgramTest,
    TestPrep,
    YjsDocsList,
    GideContract,
    // CalendarDashboard,
    SpcmCounselorCalendar,
    NotificationsModal,
    PAQ,
    ProductSubscriptionPlan
  },
  data () {
    return {
      apiName: "spcm_view",
      SendMailModules: SendMailModules,
      GideProducts: GideProducts,
      vmQuestionerForm: {},
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Student Counseling Dashboard",
      spcmObj: {},
      editMode: false,
      user_profile: {},
      extraCurricularListObj: {},
      userResponded: true,
      cvTabObj: {
        education: "Education",
        chooseSlot: "Choose your slot",
        review: "Review",
        counselling: "Counseling",
        leaderBoard: "Activities",
        chooseInterests: "Choose Interests",
        universityReco: "University List Recommendations",
        scholarshipReco: "Scholarship Recommendations",
        profileBuildingReco: "Profile Building Recommendations",
        programTest: "Programs, Exams & Tests",
        testPrepPerformance: "TestPrep Performance",
        passionProjects: "Passion Projects"
      },
      gpath_session_data: null,
      gpath_session_counnt: null,
      selectedTab: "Personal Details",
      counsellingSelectedTab: "Education",
      cvSpcmSpcmCounsellorFormTitle: "Student Onboarding Form",
      cvSpcmStudentCounsellorTeamModalHeader: "Student Counselor Team",
      studentView: true,
      counsellorView: false,
      counsellorId: null,
      addEducationShow: false,
      studentData: {},
      userProgramTest: {},
      sessionList: [],
      showSlotModal: false,
      spcmId: null,
      userAppAllResultAverage: [],
      cvLoading: true,
      questionList: [],
      leftmenuIcon: false,
      IS_MOBILE_DEVICE: true,
      PRE_COUNSELING_APP_ID: "PRE_COUNSELING_APP_ID",
      refreshScholarshipRecoKey: 0,
      showModelSendMail: false,
      cvSendMailModalHeader: "Send Email",
      sendMailObj: null,
      cvbtnModalCancel: "Cancel",
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      showModelYjs_Doc_List: false,
      cvYjsDocListModalHeader: "Student Document List",
      yjsDocsObj: null,
      showProgramTestModal: false,
      showModalGideContracts: false,
      gideCounselingContractObj: null,
      withOutEassyExtraCurricularList: false,
      mainViewTab: "session_detail",
      cvShowActivities: "Book Appointment",
      showModelSpcmStudentCounsellorTeam: false,
      showCounsellingQuizModalv1: false,
      cvSpcmHookStateMentModalHeader: "Hook Statement",
      showModelSpcmHookStatement: false,
      StudentHookStatement: null,
      StudentCounsellorTeamObj: null,
      parentList: [],
      SPCM_STATE_LIST: {},
      SPCM_STATE_COLORCODE_LIST: {},
      addressObj: {},
      applicationStatus: null,
      spcmData: null,
      showModelSpcmStatusUpdate: false,
      educationForm: {
        subjects: [],
        videoLinks: [],
        attachments: []
      },
      propSpcmObj: {},
      whereFilter: {
        student_id: ""
      },
      landedFrom: "spcm", // testseries, spcm, default is from "spcm"
      propNotificationObj: {},
      questionObj: null,
      showEditEducation: false,
      update: 0,
      contractId: "BLOGSPCMContractGIDEEXCId0002"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // set the module from which the user has landed from
    if (this.$route.path.includes("testseries")) {
      this.landedFrom = "testseries"
    }

    this.spcmId = this.$route.params.spcmId

    if (this.userData.user_role == "USERROLE11118" && this.spcmObj.counsellor_id != this.userData.user_id) {
      // Auth Access for Current User Role
      if (!userPermission(this, this.userData, this.apiName)) {
        this.$router.back()
      }
    }
  },
  async mounted () {
    socialvue.index()
    if (window.innerWidth > 991) {
      this.IS_MOBILE_DEVICE = false
    }

    this.spcmObj = await this.viewSpcmDetail()
    this.spcmObj.parent_module_name = "SPCM"

    if (!(this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") &&
      !this.spcmObj && this.spcmObj.user_id != this.userData.user_id
    ) {
      // the user is a not an Admin or Counselor
      // AND has not paid for counseling / invited / no entry in spcm
      // the user is a student is trying to open another users counseling profile
      this.$router.push("/spcm_counseling_product")
      return
    }

    // Check Contract Form is submitted or not
    if (!(this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") && !this.spcmObj.spcm_tnc) {
      let golive = 1
      if (golive == 1) {
        // Open the PAQ in a Modal Box if the Contract is not accepted by Student/Parent
        this.questionObj = {
          app_id: "PRE_COUNSELING_APP_ID",
          user_id: this.spcmObj.user_id,
          tnc_flag: this.spcmObj.spcm_tnc
        }

        this.showCounsellingQuizModalv1 = true
      }
      else {
        // Open the Contract in a Modal Box if the Contract is not accepted by Student/Parent
        this.viewContract(this.spcmObj)
      }
    }

    if (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") {
      this.studentView = false
      this.counsellorView = true
      this.counsellorId = this.userData.user_id
      this.selectedTab = this.cvTabObj.counselling

      if (this.userData.user_role == "USERROLE11118" && !this.spcmObj.counselor_team.includes(this.counsellorId) && this.spcmObj.counsellor_id != this.userData.user_id) {
        this.toastMsg = "Unauthorised access: Counselor is not a member of student team"
        this.toastVariant = "danger"
        this.showToast = true

        setTimeout(() => {
          this.$router.push("/") // Fallback to home page
        }, 3000)
      }
    }

    await this.spcmStateList()
    this.viewUserProfile()
    await this.userParentList()

    if (this.userData.user_role === "USERROLE11111" || this.userData.user_role === "USERROLE11118") {
      this.propNotificationObj = {
        module_name: "SPCM",
        module_id: this.spcmId,
        counsellorId: this.userData.user_id,
        gide_user_id: this.userData.user_id === this.studentData.user_id ? this.userData.user_id : null, // when student is viewing notifications but currently this feature is not for students
        seen_status: 0
      }
    }
  },
  methods: {
    /**
     * getUserAppAllResultAverage
     */
    async getUserAppAllResultAverage () {
      const apiResp = await AppResults.appResultAllAverage(this, { current_user_id: this.spcmObj.user_id })
      if (apiResp.resp_status) {
        this.userAppAllResultAverage = apiResp.resp_data.data
      }
    },
    /**
     * spcmSessionUpdate
     */
    spcmSessionUpdate (event) {
      if (event.session_id) {
        this.spcmObj.spcm_total_session += 1
      }
      this.selectedTab = this.cvTabObj.counselling
      this.showSlotModal = false
      // this.spcmAddEdit()
    },
    /**
     * goTo GpathsReport
     */
    async goToGpathsReport (url) {
      if (this.gpath_session_counnt > 1) {
        Utility.openUrlInNewTab(`/gpath_session_list?user_id=${this.studentData.user_id}`)
      }
      else {
        Utility.openUrlInNewTab(url, "_blank")
      }
    },
    /**
     * goTo ReportAnalysis
     *  https://web.gide.ai/app_result_analyse/APP3d1f54056a6e4704a10e691083ea961d/3ae28a5fcb108bc1ddd784521bbb4f0d?attempt=NA
     */
    async goToReportAnalysis () {
      Utility.openUrlInNewTab(`/app_result_analyse/${this.PRE_COUNSELING_APP_ID}/${this.studentData.user_id}?attempt=NA`, "_blank")
    },
    /**
     * goToDashboard
     */
    goToDashboard () {
      if (this.landedFrom == "testseries") {
        this.$router.push("/testseries_admin_dashboard")
      }
      else {
        this.$router.push("/spcm_counseling_dashboard_v1")
      }
    },
    /**
     * gotoUserProfile
     */
    gotoUserProfile (userId) {
      Utility.openUrlInNewTab(`/user/${userId}`, "_blank")
    },
    /**
     * showAddEducation
     * Safe contextual normalization wrapper to accurately auto-populate inner elements
     */
    showAddEducation () {
      this.addEducationShow = true
      this.educationSubmited = false
      this.educationForm = {
        subjects: [],
        videoLinks: [],
        attachments: []
      }
    },
    /**
     * closeEducationModal
     */
    closeEducationModal () {
      this.addEducationShow = false
    },
    /*
     * updated Education
     */
    async updatedEducationDetails (payload) {
      this.viewUserProfile()
      this.addEducationShow = false
    },
    /**
     * viewSpcmDetail
     */
    async viewSpcmDetail () {
      const spcmResp = await Spcms.spcmView(this, this.spcmId)
      if (!spcmResp.resp_status) {
        if (this.spcmId) {
          // show only if couseller view bcz incase of student it will come from user id. if spcm not found in db then it will show add form
          // ApiResponse.responseMessageDisplay(this, spcmResp)
        }
        else {
          this.spcmObj.user_id = this.userData.user_id
          this.studentData = this.userData
          this.viewUserProfile()
        }
        this.cvLoading = false
        return
      }

      this.spcmObj = spcmResp.resp_data.data
      this.applicationStatus = this.spcmObj.spcm_state
      this.spcmId = this.spcmObj.spcm_id
      this.spcmObj.user_id = this.spcmObj.user_id

      if (this.userData.user_id === this.spcmObj.user_id) {
        this.studentData = this.userData
      }
      else {
        this.studentData = spcmResp.resp_data.user_detail
        this.addressObj = JSON.parse(this.studentData.user_address)
      }

      this.viewUserProfile()

      if (!this.spcmObj.spcm_total_session) {
        this.spcmObj.spcm_total_session = 0
      }

      // If there exists an entry in the spcm table then it implies that the user is onboarded, and we do not need to collect his personal details and interests
      if (this.spcmObj.spcm_total_session >= 0) {
        this.selectedTab = this.cvTabObj.counselling
      }

      if (this.counsellorView) {
        this.getUserAppAllResultAverage()
      }
      this.getSpcmQuizResponse()
      this.cvLoading = false
      return this.spcmObj
    },
    /**
     * getSpcmQuizResponse
    */
    async getSpcmQuizResponse () {
      let payload = {
        app_category: "Pre-Counselling",
        curr_user_id: this.spcmObj.user_id
      }
      const resp = await QuizBanks.quizBankUserResponse(this, payload)
      if (resp.resp_status) {
        this.questionList = resp.resp_data.data
        this.userResponded = false
      }
    },
    /**
     * viewUserProfile
     */
    async viewUserProfile () {
      this.whereFilter.withOutEassyExtraCurricularList = true
      const userProfile = await User.userProfileView(this, this.spcmObj.user_id, this.whereFilter)
      if (userProfile.resp_status) {
        this.extraCurricularListObj = userProfile.resp_data.data.extraCurricularListObj

        if (userProfile.resp_data.data.user_profile) {
          if (typeof userProfile.user_profile === "string") {
            this.user_profile = JSON.parse(userProfile.resp_data.data.user_profile)
          }
          else {
            this.user_profile = userProfile.resp_data.data.user_profile
          }
        }

        if (userProfile.resp_data.data.user_program_test) {
          this.userProgramTest = JSON.parse(userProfile.resp_data.data.user_program_test)
        }
      }
    },
    /**
     * goToNextTab
     */
    goToNextTab () {
      switch (this.selectedTab) {
        case this.cvTabObj.education:
          this.selectedTab = this.cvTabObj.chooseInterests
          break
        case this.cvTabObj.chooseInterests:
          this.selectedTab = this.cvTabObj.chooseSlot
          break
        case this.cvTabObj.chooseSlot:
          // seesion add will call
          break
        case this.cvTabObj.review:
          this.selectedTab = this.cvTabObj.counselling
          break
        case this.cvTabObj.counselling:
          this.$router.push("/spcm_dashboard")
          break
        default:
          break
      }
    },
    /**
     * spcmAddEdit
     */
    async spcmAddEdit () {
      try {
        let payload = {
          spcm_state: null,
          spcm_id: this.spcmId,
          counsellor_id: this.counsellorId
        }
        let apiResp = null

        if (this.spcmId) {
          if (this.studentView && this.selectedTab == this.cvTabObj.review) {
            switch (this.spcmObj.spcm_state.toString()) {
              case "1":
                payload.spcm_state = SPCMStateNumberJson[Number(this.spcmObj.spcm_state) + 1] // SPCM_DONE
                break
              default:
                this.$router.back()
                break
            }
          }
          apiResp = await Spcms.spcmEdit(this, payload)
        }
        else {
          payload.spcm_state = SPCMStateNumberJson[1]
          apiResp = await Spcms.spcmAdd(this, payload)
          if (apiResp.resp_status) {
            this.spcmId = apiResp.resp_data.spcm_id
            this.viewSpcmDetail()
          }
          else {
            ApiResponse.responseMessageDisplay(this, apiResp)
          }
        }
      }
      catch (error) {
        console.error("Exception in spcmAddEdit()", error)
      }
    },
    /**
     * refreshScholarshipReco
     */
    refreshScholarshipReco () {
      this.refreshScholarshipRecoKey++
    },

    /**
     * openSendmailToUserModal
     */
    openSendmailToUserModal () {
      this.sendMailObj = {
        module_name: this.GideProducts.COUNSELLING,
        module_obj_id: this.spcmObj.spcm_id,
        user_id: this.studentData.user_id,
        counsellor_id: this.spcmObj.counsellor_id,
        spcm_id: this.spcmObj.spcm_id,
        user_name: this.studentData.user_name,
        user_email: this.studentData.user_email,
        cc_email: this.studentData.user_email,
        subject: {}
      }

      for (let key in this.SendMailModules) {
        if (key.includes("SPCM")) {
          this.sendMailObj.subject[key] = this.SendMailModules[key]
        }
      }

      this.showModelSendMail = true
    },
    /**
     * emitCloseGPathSendMailModal
     */
    async emitCloseGPathSendMailModal () {
      this.showModelSendMail = false
    },
    /**
      * openStudentDocsList
      */
    openStudentDocsList (item) {
      try {
        item.module_name = "SPCM"
        item.module_object_id = this.spcmId
        this.yjsDocsObj = item
        this.showModelYjs_Doc_List = true
      }
      catch (err) {
        console.error("Exception occurred at showModelYjs_Doc_List() and Exception:", err.message)
      }
    },
    /**
     * closeStudentDocsList
     */
    closeStudentDocsList () {
      this.showModelYjs_Doc_List = false
    },
    /**
     * showAddProgramAndTest
      */
    showProgramModal () {
      this.showProgramTestModal = true
      this.programEditObj = {}
    },
    /**
     * closeProgramModal
     */
    closeProgramModal (event) {
      if (event) {
        this.userProgramTest = JSON.parse(event.resp_data.user_program_test)
      }
      this.showProgramTestModal = false
    },
    /**
     * openAdmission
     */
    openAdmission (userId) {
      this.$router.push(`/admission_dashboard/${userId}`)
    },
    /**
     * view Gide contracts
     */
    viewContract (spcmObj) {
      if (spcmObj?.spcm_category?.includes("EXCLUSIVE") || spcmObj?.spcm_tnc == 1) {
        this.gideCounselingContractObj = spcmObj
        this.gideCounselingContractObj.tnc_flag = spcmObj.spcm_tnc
        this.gideCounselingContractObj.contract_attached_file = spcmObj.spcm_contract
        this.gideCounselingContractObj.blog_id = this.contractId
        this.showModalGideContracts = true
      }
      else {
        this.toastMsg = "You have not opted for GIDE Exclusive, our Premium Counseling Services."
        this.toastVariant = "danger"
        this.showToast = true
      }
    },
    /**
     * close GIDECounselingContractModal
     */
    closeGIDECounselingContractModal () {
      this.viewSpcmDetail()
      this.showModalGideContracts = false
      this.showCounsellingQuizModalv1 = false
    },
    /**
     * closeStudentCounsellorTeamModal
     */
    closeStudentCounsellorTeamModal (updatedData) {
      try {
        // Update the List with new Information
        for (let i in this.spcmObjList) {
          if (this.spcmObjList[i].spcm_id == updatedData.spcm_id) {
            this.spcmObjList[i] = updatedData
            break
          }
        }

        this.updateInfo = this.updateInfo + 1
        this.showModelSpcmStudentCounsellorTeam = false
      }
      catch (err) {
        console.error("Exception occurred at closeStudentCounsellorTeamModal() and Exception:", err.message)
      }
    },
    /**
     * getFirstLetterOfAString
     */
    getFirstLetterOfAString (string) {
      if (string) {
        return string.substr(0, 1)
      }
    },
    /**
     * userParentList
     */
    async userParentList () {
      try {
        const userParentListResp = await UserParent.user_parentList(this, this.studentData.user_id)
        if (userParentListResp.resp_status) {
          this.parentList = userParentListResp.resp_data.data
        }
      }
      catch (error) {
        console.error("Exception in userParentList", error)
      }
    },
    /**
     * spcmStateList
     */
    async spcmStateList () {
      try {
        let spcmStateListResp = await Spcms.spcmStateList(this)
        if (spcmStateListResp.resp_status) {
          let stateObjList = spcmStateListResp.resp_data.data
          for (let stateObj of stateObjList) {
            this.SPCM_STATE_LIST[stateObj.state_id] = stateObj.state
            this.SPCM_STATE_COLORCODE_LIST[stateObj.state_id] = stateObj.state_color_code
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmStateList() and Exception:", err.message)
      }
    },
    /**
     * close Spcm Country Strategy Modal
     */
    closeSpcmCountryStrategyModal (updatedData) {
      try {
        // Update the List with new Information
        for (let i in this.spcmObjList) {
          if (this.spcmObjList[i].spcm_id == updatedData.spcm_id) {
            this.spcmObjList[i] = updatedData
            break
          }
        }

        this.updateInfo = this.updateInfo + 1
      }
      catch (err) {
        console.error("Exception occurred at closeSpcmCountryStrategyModal() and Exception:", err.message)
      }
    },
    /**
     * get Counselling State Color Code
     */
    getCounsellingStateColorCode (stateId) {
      if (stateId == "tnc_1") {
        return `vertical-align: middle; color: #FFF; background: green !important;`
      }
      else if (stateId == "tnc_0") {
        return `vertical-align: middle; color: #FFF; background: orange !important;`
      }
      else if (stateId == 99) {
        return `vertical-align: middle; color: #FFF; background: orange !important;`
      }
      else if (stateId == 98) {
        return `vertical-align: middle; color: #FFF; background: #e5252c !important;`
      }
      else {
        return `vertical-align: middle; color: #FFF; background: ${this.SPCM_STATE_COLORCODE_LIST[stateId]} !important;`
      }
    },
    /**
     * spcmStudentCounsellorTeam
     */
    spcmStudentCounsellorTeam (item) {
      try {
        item.user_name = this.studentData.user_name
        this.StudentCounsellorTeamObj = item
        this.showModelSpcmStudentCounsellorTeam = true
      }
      catch (err) {
        console.error("Exception occurred at spcmStudentCounsellorTeam() and Exception:", err.message)
      }
    },
    /**
     * spcmStudentCounsellorTeam
     */
    spcmHookStatementAddEdit (item) {
      try {
        this.StudentHookStatement = item
        this.showModelSpcmHookStatement = true
      }
      catch (err) {
        console.error("Exception occurred at spcmHookStatementAddEdit() and Exception:", err.message)
      }
    },
    /**
     * updateHookStatement
     */
    async updateHookStatement (item) {
      try {
        // Prepare the payload for the API
        let payload = {
          spcm_id: this.spcmId,
          spcm_hook: this.StudentHookStatement.spcm_hook
        }

        const apiResp = await Spcms.spcmEdit(this, payload)
        if (apiResp.resp_status) {
          // Show success message
          this.toastMsg = "Hook Statement updated successfully"
          this.toastVariant = "success"
          this.showToast = true
          this.showModelSpcmHookStatement = false
          this.viewSpcmDetail()
        }
        else {
          ApiResponse.responseMessageDisplay(this, apiResp)
        }
      }
      catch (error) {
        console.error("Exception in updateHookStatement()", error)
        this.toastMsg = "Failed to update Hook Statement"
        this.toastVariant = "danger"
        this.showToast = true
      }
    },
    /**
     * show Spcm Status Update Dialog
     */
    showSpcmStatusUpdateOpenDialog (spcmObj) {
      this.spcmObj = {
        spcm_id: spcmObj.spcm_id
      }
      this.showModelSpcmStatusUpdate = true
    },
    /**
     * spcm Status Update
     */
    async spcmStatusUpdate (spcmObj, newState) {
      try {
        this.cvLoadingStatus = true

        let payload = {
          spcm_id: spcmObj.spcm_id,
          spcm_state: newState
        }
        let spcmAddResp = await Spcms.spcmStateEdit(this, payload)
        await ApiResponse.responseMessageDisplay(this, spcmAddResp)

        if (spcmAddResp && !spcmAddResp.resp_status) {
          return false
        }

        spcmObj.spcm_state = newState
        this.showModelSpcmStatusUpdate = false
        this.viewSpcmDetail()
      }
      catch (err) {
        console.error("Exception occurred at spcmStatusUpdate() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * goto Fireflies Dashboard
     */
    gotoFirefliesDashboard () {
      this.$router.push(`/FireFliesList`)
    },
    /**
     * Open PreCounselling Quiz Modal V1
     */
    openCounsellingQuizModalv1 (spcmObj) {
      this.questionObj = {
        ...spcmObj,
        app_id: "PRE_COUNSELING_APP_ID"
      }

      this.showCounsellingQuizModalv1 = true
      this.update = this.update + 1
    },
    /**
     * close PreCounselling Quiz Modal
     */
    closeCounsellingQuizModal () {
      this.showCounsellingQuizModalv1 = false
    },
    /**
     * Spcms TnC Accept and contract upload
     */
    async contractTnCAccept (contractObj = null) {
      if (contractObj) {
        const isModalAcceptance = contractObj && Array.isArray(contractObj.spcm_contract)
        const isToggleRequest = typeof contractObj === "object" && !isModalAcceptance
        const selectedContract = isToggleRequest ? contractObj : this.gideCounselingContractObj

        if (!selectedContract || !selectedContract.spcm_id) {
          return false
        }

        const spcmTnc = isToggleRequest ? (Number(selectedContract.spcm_tnc) === 1 ? 0 : 1) : (contractObj.acceptTnc ? 1 : Number(selectedContract.spcm_tnc))
        const payload = {
          spcm_id: selectedContract.spcm_id,
          spcm_category: selectedContract.spcm_category,
          spcm_tnc: spcmTnc
        }

        if (isModalAcceptance) {
          payload.spcm_contract = contractObj.spcm_contract
        }
        const spcmEditResp = await Spcms.spcmEdit(this, payload)

        await ApiResponse.responseMessageDisplay(this, spcmEditResp)

        if (!spcmEditResp || !spcmEditResp.resp_status) {
          return false
        }

        selectedContract.spcm_tnc = spcmTnc
        if (isToggleRequest) {
          this.updateInfo = this.updateInfo + 1
        }
        else {
          this.closeGIDECounselingContractModal()
        }
      }
      else {
        let payload = {
          spcm_id: this.spcmObj.spcm_id,
          spcm_tnc: 1
        }

        Spcms.spcmEdit(this, payload)
        this.closeGIDECounselingContractModal()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .educationAddIcon {
    float: right;
    color: var(--iq-primary);;
    z-index: 999;
    position: relative;
  }
  .dropdown-item{
    color: #212529 !important;
  }
  .dropdown-menu .dropdown-item:focus, .dropdown-menu .dropdown-item:hover{
    background: transparent;
    color: var(--iq-primary) !important;
  }
  .logo-icon{
    height: 50px !important;
    width: 50px !important;
    overflow: hidden;
    object-fit: cover;
    pointer-events: none;
    border-radius: 50%;
  }
  .w-full{
    width: 100%;
  }
  .btn-opacity{
    border: none ;
    outline : none;
    background:#fff;
    width: 100%;
  }
  .btn-opacity:hover{
    color: var(--iq-primary)
  }
  .line-wrap{
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
  }
  .grid{
    display: grid;
    grid-template-columns: repeat(3, 1fr)
  }
  @media screen and (max-width: 768px){
    .grid{
       grid-template-columns: 0.9fr 1.2fr 0.9fr
    }
  }
  #photo-grid img {
    background: #FFFFFF!important;
    object-fit: fill;
  }
  .leftArrowIcon {
    position: absolute;
    left: 0px;
    z-index: 99;
    bottom: 0;
    top: 0;
    margin: auto;
    height: 32px;
    background-color: transparent !important;
    border: none;
    i {
      font-size: 22px;
    }
  }
  .rightArrowIcon {
    position: absolute;
    right: 0px;
    z-index: 99;
    bottom: 0;
    top: 0;
    margin: auto;
    height: 32px;
    background-color: transparent !important;
    border: none;
    i {
      font-size: 22px;
    }
  }
  .review_form_spacingSPCM {
    padding: 11px !important;
    z-index: 100;
  }
  .questionContainer {
    white-space: normal;
    height: 100%;
    width: 100%;
  .optionContainer {
      margin-top: 0px;
      flex-grow: 1;
      .option {
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 5px 10px 5px 50px;
        cursor: pointer;
        border: transparent 1px solid #f1f1f1;
        position: relative;
        border: 1px solid #f1f1f1;
        overflow: hidden;
        font-size: 18px;
        height: 40px;
        &.is-selected {
          border-color: var(--iq-primary);
          background-color: white;
        }
        &.is-correct {
          border-color: rgb(92, 180, 92);
        }
      }
    }
    .questionFooter {
      width: 100%;
      align-self: flex-end;
      .pagination {
        /* padding: 10px 15px; */
        margin: 15px 25px;
      }
      .progressContainer {
         /* margin: 15px 25px; */
      }
    }
  }
  .optionNo {
  position: absolute;
  top: 0;
  bottom: 0px;
  width: 40px;
  background-color: #f1f1f1;
  left: 0px;
  }
  .optionNo span {
    position: absolute;
    right: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
    width: 17px;
    height: 23px;
    font-weight: 500;
    line-height: initial;
    font-size: 18px;
  }

  #pills-tab-1{
    li a{
    border-radius: 0px !important;
    }
  }
  #pills-tab-1.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{
    border-bottom:1px solid !important;
    }
  @media screen and (max-width: 991px){
    .right_data{
      position: absolute;
      top: 0;
      bottom: 0;
      background: #00000038;
      min-height: 100%;
      margin: auto;
      height:max-content;
      max-width: 100%;
      z-index: 99999;
    }
    .right_data_center{
      margin: auto;
      background: #fff;
    }
    .main-circle{
      float: right;
      font-size: 20px;
      display: block !important;
    }
    .menu_icon_right{
      position: absolute;
      right: 8px;
      top: 12px;
    }
    .menu_icon_left{
      position: absolute;
      left: 8px;
      top: 12px;
    }
  }
  @media screen and (min-width: 991px){
  .right_data{
    display: block;
    }
  }
  .main-circle{
    display: none;
  }
  .close_right_data{
    float: right;
    font-size: 19px !important;
    position: absolute;
    top: 3px;
    right: 6px;
  }
  .close_left_data{
    float: right;
    font-size: 19px !important;
    position: absolute;
    top: 5px;
    right: 6px;
  }
.Documents{
  .document_hr_color{
    border-color: var(--iq-primary) !important;
  }
  .document_card{
    padding-left: 0px !important;
    box-shadow: none !important;
  }
}
.iq-header-title{
  width: 100%;
}
.bg-color{
  background-color: transparent !important;
  border: 0px;
}
div.profile-img-edit{
  display: flex !important;
  align-items: center !important;
  height: unset !important;
  width: auto !important;
}
.user_details i{
  color: #e5252c;
  width: 15px
}
.parent_detail_row{
    gap: 6px;
}
.parent_detail_col{
  flex: 1 1 0;
  overflow-wrap: break-word;
}
.badge {
  padding: 0.3em 0.6em 0.5em 0.6em !important;
}
</style>
